import {SetAttributes} from './Edit';
import {SelectControl} from '@wordpress/components';
import {__} from '@wordpress/i18n';
import {CONFIG} from '../../../globals/config';
import {isEmpty} from 'lodash';

export type MenuOptions = {
	navigation_menu: number;
}

type Props = {
	attributes: MenuOptions;
	setAttributes: SetAttributes;
}

const Menu = ( {attributes, setAttributes}: Props ) => {
	if ( isEmpty( CONFIG.menus ) ) {
		return null;
	}

	return (
		<SelectControl
			label={__( 'Select Menu', 'advanced-sidebar-menu' )}
			value={attributes.navigation_menu.toString()}
			options={[ {
				label: __( '- no menu -', 'advanced-sidebar-menu' ),
				value: '0',
			}, ...Object.entries( CONFIG.menus ).map( ( [ value, label ] ) => ( {
				label,
				value,
			} ) ) ]}
			onChange={value => setAttributes( {
				navigation_menu: parseInt( value ),
			} )}
		/>
	);
};

export default Menu;
